// libraries
import React from "react";
import { useTable, useFlexLayout, useExpanded } from "react-table";

const AppReactTable = ({
  columns,
  data,
  onClickRow,
  headerClass,
  headerRowClass,
  rowHeaderClass,
  bodyClass,
  bodyRowClass,
  bodyDataClass,
  renderRowSubComponent,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow,visibleColumns } =
    useTable(
    {
      columns,
      data,
      initialState: {
        expanded: data.reduce((acc, item, index) => {
          if (item.status === "PENDING_UPDATE") {
            acc[index] = true;
          }
          return acc;
        }, {})
      }
    },
    useFlexLayout,
    useExpanded
  );

  if (headerClass === null || headerClass === undefined) {
    headerClass = "header";
    headerRowClass = "header__row";
    rowHeaderClass = "header__row-header";
  }

  if (bodyClass === null || bodyClass === undefined) {
    bodyClass = "body";
    bodyRowClass = "body__row";
    bodyDataClass = "body__row-data";
  }

  function enableStrike(values) {
    if (bodyClass === "invoiceHistoryBody" && values.isValid === false) {
      bodyDataClass += " invoiceHistoryBody__text-red";
    } else if (bodyClass === "invoiceHistoryBody") {
      bodyDataClass = "invoiceHistoryBody__row-data";
    } else {
      bodyDataClass = "body__row-data";
    }
  }

  return (
    <div className="app-react-table">
      <div className="app-react-table__content">
        <table {...getTableProps()} className="app-react-table__table-wrapper">
          <thead className={headerClass}>
            {headerGroups.map((headerGroup, index) => (
              <tr
                key={`tr_${index}`}
                className={headerRowClass}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={`th_${index}`}
                    className={rowHeaderClass}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {data[0] != null || data[0] != undefined ? (
            <tbody {...getTableBodyProps()} className={bodyClass}>
              {rows.map((row, i) => {
                prepareRow(row);
                enableStrike(row.values);
                const isPending =
                  row.original.status === "PENDING_CREATE" ||
                  row.original.status === "PENDING_DELETE";
                  return (
                    <React.Fragment key={`fragment_${i}`}>
                      <tr
                        key={`tr_${i}`}
                        {...row.getRowProps({ style: { color: isPending ? "red" : "initial" } })}
                        className={bodyRowClass}
                        onClick={() => (onClickRow ? onClickRow(row.original) : null)}
                      >
                        {row.cells.map((cell, index) => (
                          <td key={`td_${index}`} className={bodyDataClass} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                      {row.isExpanded && renderRowSubComponent && (
                        <tr className={`${bodyRowClass} expanded-row`}>
                          <td colSpan={visibleColumns.length} className={bodyDataClass} style={{ color: 'red' }}>
                            {renderRowSubComponent({ row })}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
              })}
            </tbody>
          ) : (
            <tbody {...getTableBodyProps()} className={bodyClass}>
              <tr>
                <td className={bodyDataClass + "_empty-message"}>
                  There are no data to be displayed.
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default AppReactTable;
